import { getCurrencyText } from '@/core/helpers/display';
import getSale from '@/core/helpers/get-sale';

function getRoundedPrice(value, configuration) {
    let valueRounded = value;
    if (
        !isNaN(valueRounded) && valueRounded !== null && value.toFixed &&
        configuration.minimumFractionDigits
    ) {
        valueRounded = value.toFixed(configuration.minimumFractionDigits).replace('.', ',');
    }
    return valueRounded;
}

const OfferPrice = ({ props, parent }) => {
    const { offer, currency, showOldPrice, showSale } = props;
    let { price, oldPrice } = offer;

    const offerCurrency = currency || getCurrencyText(offer.currency);

    let sale = 0;

    if (price) {
        price = getRoundedPrice(price, parent.$configuration);

        if (oldPrice) {
            sale = getSale(price, oldPrice);
        }
    }

    let saleNodes = [];

    if (sale) {
        if (showSale) {
            saleNodes = [
                <span class="l-ss-c-offer-sale">{`- ${sale}%`}</span>,
            ];
        }

        if (showOldPrice) {
            saleNodes.unshift(
                <span class="l-ss-c-offer-old-amount">{`${oldPrice.toLocaleString()}`} {offerCurrency}</span>,
            );
        }
    }

    return (
        <div class="l-ss-c-offer-price">
            {...saleNodes}

            {
                price ?
                    <span class="l-ss-c-offer-amount">{`${price.toLocaleString()} ${offerCurrency}`}</span> :
                    null
            }
        </div>
    );
};

OfferPrice.props = {
    offer: {
        type: Object,
    },
    currency: {
        type: String,
    },
    showOldPrice: {
        type: Boolean,
        default: true,
    },
    showSale: {
        type: Boolean,
        default: true,
    },
};

export default OfferPrice;
